export default {
  icons: {
    cardView: 'view_module',
    filterList: 'filter_list',
    goBack: 'arrow_back',
    refresh: 'refresh',
    tabView: 'view_headline',
  },
  unknown_user: 'Non connecté(e)',
  settings: 'Paramètres',
  logout: 'Déconnexion',
  login: 'Connexion',
  light: 'Thème clair',
  dark: 'Thème sombre',
  scrollOffNavbarOff: 'Garder la barre de navigation',
  scrollOffNavbarOn: 'Escamoter la barre de navigation',
  resetPreferences: 'Réinitialiser mes préférences',
  FAQ_link: 'FAQ',
  MYP_portal_link: 'Portail MyPredity',
  yammer_link: 'Yammer MyPredity',
  disconnected_message: 'Vous êtes déconnecté.',
  next_page: 'Page suivante',
  previous_page: 'Page précédente',
  first_page: 'Première page',
  checkAll: 'Tout cocher',
  unCheckAll: 'Tout décocher',
  notifications: {
    title: 'Notifications',
    icon: 'notifications',
    haveUnread: 'Uniquement les non lues',
  },
  goBack: 'Précédent',
  refresh: 'Rafraichir les données',
  lastRefresh: 'Dernier rafraichissement',
  showFilters: 'Afficher les filtres',
  hideFilters: 'Masquer les filtres',
  filters: {
    date: 'Filtrer par date',
    dateMax: 'Date maximun',
    dateMin: 'Date minimum',
    from: 'A partir du {date}',
    icons: {
      infos: 'mdi-information-variant',
    },
    fromTo: 'Du {dateMin} au {dateMax}',
    fromToHours: 'De {min} h à {max} h',
    entity: 'Entité',
    contract: 'Contrat',
    business_id: 'Affaire',
    properties: 'Installation',
    customers: 'Client',
    regulatory_control_code: 'Contrôles réglementaires',
    clearAll: 'Vider les filtres',
    reset: 'Réinitialiser les filtres',
    search: 'Rechercher',
    searchIn: 'Rechercher dans',
    til: "Jusqu'au {date}",
    title: 'Filtres',
    validate: 'Valider',
  },
  units: {
    temperature: '{number} °C',
    energy: '{number} kwh',
    time: {
      d: '{day}j',
      h: '{hour}h',
      m: '{min}m',
    },
    hour: '{number}h',
    none: '{number}',
    currency: '{number} €',
  },
  view: {
    cards: 'Vue cartes',
    tab: 'Vue tableau',
  },
  excelExport: {
    btnLabel: 'Export .xlsx',
    title: 'Export Excel',
    icon: 'mdi-file-excel',
    extract: 'Extraire',
    pageSize: 'Lignes par page',
    page: 'N° de page',
    entities: 'Organisations',
    search: 'Recherche',
    dateMin: 'Date Min',
    dateMax: 'Date Max',
  },
  mobileeDeployed:
    "Une partie de votre périmètre a été déployée dans Mobilee. Les données affichées sont susceptibles d'être incomplètes.",
};
